import React from 'react';
import {
  Button, Col, Form, Input, Row, Select, Typography
} from 'antd';
import {
  applicationStatusList,
  applicationtypeList,
  sortOrderList
} from '../constant';

const { Title, Text } = Typography;
const { Option } = Select;

const CourseApplicationsForm = ({
  form,
  resetForm,
  onFinish,
  totalCount,
  courseList
}) => {
  return (
    <Form form={form} onFinish={onFinish}>
      <Row justify="space-between">
        <Title level={4}>Filters</Title>
        <Text strong>Total Count: {totalCount}</Text>
      </Row>

      <Row gutter={16}>
        <Col span={4}>
          <Form.Item name="applicationSearch">
            <Input placeholder="Enter Search Text" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="courseCode">
            <Select
              placeholder="Select Course Code"
              defaultValue={courseList?.[0]?.value}>
              {courseList?.map((option, index) => (
                <Option key={index} value={option?.value}>
                  {option?.text}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="sortOrder">
            <Select
              placeholder="Sort by time"
              showSearch={true}
              defaultValue={sortOrderList[0].value}>
              {sortOrderList?.map((option, index) => (
                <Option key={index} value={option.value}>
                  {option.text}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="status">
            <Select placeholder="Pending/Approve/Rejected">
              {applicationStatusList?.map((option, index) => (
                <Option key={index} value={option.value}>
                  {option.text}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="type">
            <Select placeholder="call/application">
              {applicationtypeList?.map((option, index) => (
                <Option key={index} value={option.value}>
                  {option.text}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col>
          <Button type="primary" htmlType="submit">
            Search
          </Button>
        </Col>
        <Col>
          <Button htmlType="button" onClick={resetForm}>
            Clear
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default CourseApplicationsForm;
